import { useEffect, useState } from "react";
import { getCalculatedOverall, positions } from "shared/utils/player.js";
import { getPlayersFromClub } from "shared/services/api-mfl.js";
import MiscOverall from "shared/components/misc/MiscOverall.js";
import LoadingSquare from "shared/components/loading/LoadingSquare.js";
import "./MiscDepthField.css";

const positionStyle = {
  GK: { top: "90%", left: "50%" },
  CB: { top: "75%", left: "50%" },
  LB: { top: "75%", left: "25%" },
  RB: { top: "75%", left: "75%" },
  LWB: { top: "64%", left: "15%" },
  RWB: { top: "64%", left: "85%" },
  CDM: { top: "60%", left: "50%" },
  CM: { top: "48%", left: "50%" },
  LM: { top: "48%", left: "25%" },
  RM: { top: "48%", left: "75%" },
  CAM: { top: "36%", left: "50%" },
  LW: { top: "18%", left: "20%" },
  RW: { top: "18%", left: "80%" },
  CF: { top: "21%", left: "50%" },
  ST: { top: "8%", left: "50%" },
};

const MiscDepthField = ({ clubId }) => {
  const [players, setPlayers] = useState(null);

  const fetchPlayers = () => {
    getPlayersFromClub({
      handleSuccess: (v) => setPlayers(v),
      handleError: (e) => console.log(`Error fetching squad for club ID ${clubId}:`, e),
      clubId: clubId,
    });
  };

  const getTopPlayersForPosition = (positionName) => {
    if (!players) return [];

    return [...players]
      .map((p) => ({
        player: p.metadata,
        ovr: getCalculatedOverall(p.metadata, positionName),
      }))
      .filter((p) => p.ovr > 0)
      .sort((a, b) => b.ovr - a.ovr)
      .slice(0, 4);
  };

  useEffect(() => {
    fetchPlayers();
  }, []);

  return (
    <div
      className="MiscDepthField football-field"
      style={{
        position: "relative",
        width: "100%",
        paddingTop: "100%",
        backgroundColor: "#e0f7fa",
        border: "2px solid #006064",
        overflow: "hidden",
      }}
    >
      <div className="football-field-lines">
        <div className="halfway-line" />
        <div className="center-circle" />
        <div className="goal-box" />
      </div>

      {players === null && (
        <div className="football-field-lines" style={{ position: "absolute" }}>
          <LoadingSquare height={"100%"} />
        </div>
      )}

      {players &&
        positions.map((pos) => {
          const topPlayers = getTopPlayersForPosition(pos.name);

          const style = {
            position: "absolute",
            width: "20%",
            minHeight: "1px",
            ...positionStyle[pos.name],
            transform: "translate(-50%, -50%)",
            backgroundColor: "rgba(33, 37, 41, .9)",
            color: "#fff",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "11px",
            padding: "2px 4px 4px 4px",
            gap: "2px",
            lineHeight: 1,
          };

          return (
            <div key={pos.name} style={style}>
              <div style={{ fontWeight: "bold" }}>{pos.name}</div>

              {topPlayers.map(({ player }) => (
                <div className="d-flex flex-column w-100">
                  <div className="d-flex flex-row">
                    <div className="d-flex flex-fill text-truncate">{player.lastName}</div>
                    <div className="d-flex" style={{ width: 35 }}>
                      <MiscOverall player={player} actualPosition={pos.name} calculatedOvr={true} />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          );
        })}
    </div>
  );
};

export default MiscDepthField;
